import React from 'react';
import { ArrowLeft, BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const GLOSSARY_ITEMS = [
  { abbr: "Ant. jud.", full: "Antiquités judaïques", desc: "Œuvre historique majeure de Flavius Josèphe relatant l'histoire du peuple juif." },
  { abbr: "Cf.", full: "Confer", desc: "Du latin signifiant « reportez-vous à » ou « comparez avec »." },
  { abbr: "De Civ. Dei", full: "De Civitate Dei (La Cité de Dieu)", desc: "Œuvre fondamentale de saint Augustin d'Hippone." },
  { abbr: "Dict. de la Bible", full: "Dictionnaire de la Bible", desc: "Monumental dictionnaire d'exégèse dirigé par Fulcran Vigouroux, collaborateur de Fillion." },
  { abbr: "Guerre des Juifs", full: "La Guerre des Juifs", desc: "Récit historique de Flavius Josèphe sur la révolte juive contre Rome." },
  { abbr: "Hebr.", full: "Hébreu", desc: "Fait référence au texte biblique original en langue hébraïque." },
  { abbr: "LXX", full: "La Septante", desc: "Traduction grecque ancienne de l'Ancien Testament, très utilisée par l'Église primitive." },
  { abbr: "M. T.", full: "Texte Massorétique", desc: "Le texte hébreu officiel de la Bible, fixé par les savants juifs (massorètes)." },
  { abbr: "Man. bibl.", full: "Manuel Biblique", desc: "Manuel d'Écriture Sainte (souvent celui de Vigouroux, Bacuez, Brassac, auquel Fillion a participé), grand classique de l'exégèse catholique française." },
  { abbr: "Pesh.", full: "La Peshitta", desc: "La traduction de la Bible en langue syriaque." },
  { abbr: "Sept.", full: "La Septante", desc: "Traduction grecque de l'Ancien Testament (voir LXX)." },
  { abbr: "Talm.", full: "Le Talmud", desc: "Compilation fondamentale de la loi orale et des commentaires rabbiniques du judaïsme." },
  { abbr: "Targ.", full: "Targum", desc: "Traduction et commentaire de la Bible hébraïque en araméen." },
  { abbr: "Vulg.", full: "La Vulgate", desc: "Traduction latine de la Bible réalisée principalement par saint Jérôme, texte de référence de l'Église catholique." }
];

const GlossaryPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-paper pb-20">
      <header className="sticky top-0 z-40 bg-paper/95 backdrop-blur supports-[backdrop-filter]:bg-paper/80 border-b border-border">
        <div className="flex items-center h-14 px-4 gap-3">
          <button 
            onClick={() => navigate(-1)}
            className="p-2 -ml-2 rounded-full hover:bg-muted text-ink-secondary transition-colors"
            aria-label="Retour"
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
          <div className="flex items-center gap-2">
            <BookOpen className="h-5 w-5 text-rubric-red" />
            <h1 className="font-heading text-lg font-semibold text-ink-primary">Glossaire des Abréviations</h1>
          </div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8">
        <div className="prose prose-stone dark:prose-invert max-w-none">
          <p className="text-ink-secondary mb-8 font-body leading-relaxed">
            L'abbé Fillion utilise fréquemment des abréviations pour citer ses sources, des traductions anciennes ou d'autres manuels d'exégèse. Retrouvez ici la signification des abréviations les plus courantes.
          </p>

          <div className="grid gap-4">
            {GLOSSARY_ITEMS.sort((a, b) => a.abbr.localeCompare(b.abbr)).map((item, index) => (
              <div key={index} className="bg-muted/30 p-4 rounded-lg border border-border">
                <div className="flex flex-col sm:flex-row sm:items-baseline gap-1 sm:gap-3 mb-2">
                  <span className="font-serif font-bold text-rubric-red text-lg">{item.abbr}</span>
                  <span className="font-heading font-semibold text-ink-primary">{item.full}</span>
                </div>
                <p className="font-body text-ink-secondary text-sm leading-relaxed m-0">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default GlossaryPage;
